<div class="batch-settings">
  <span class="batch-settings-title"> {{ 'batchSettings' | translate }} </span>
  <form
    class="batch-form"
    [formGroup]="batchFormGroup"
  >
    @if (showBatchId) {
      <label for="batchId">
        {{ 'batchId' | translate }}
        <input
          type="text"
          id="batchId"
          pInputText
          formControlName="batchId"
          pSize="large"
          [placeholder]="'batchId' | translate"
          [disabled]="true"
        />
      </label>
    }
    <label for="batchName">
      {{ 'batchName' | translate }}
      <input
        pInputText
        type="text"
        id="batchName"
        formControlName="name"
        pSize="large"
        [placeholder]="'batchName' | translate"
      />
    </label>
    <label
      class="required-label"
      for="departmentSelect"
    >
      {{ 'department' | translate }}
      <span class="required-text">*</span>
    </label>
    <div class="select-container">
      <p-select
        placeholder="{{ 'selectDepartmenr' | translate }}"
        class="dap-select-department"
        formControlName="department"
        optionLabel="name"
        optionValue="code"
        filterBy="name"
        id="departmentSelect"
        size="large"
        aria-required="true"
        [options]="departments"
        [filter]="true"
        [appendTo]="'body'"
      >
      </p-select>
    </div>
    @if (
      batchFormGroup.controls['department']?.errors &&
      batchFormGroup.controls['department']?.touched
    ) {
      <span class="required-text">
        {{ 'departmentRequired' | translate }}
      </span>
    }

    <span class="optional-settings">{{ 'optionalSettings' | translate }}</span>
    @if (isEditing) {
      <small id="defaultAreaDoctypeDescription">
        {{ 'editingBatchDefaultsWarning' | translate }}
      </small>
    }

    <label
      class="default-area"
      for="defaultArea"
    >
      {{ 'defaultArea' | translate }}
      <div class="select-container">
        <p-select
          placeholder="{{ 'defaultAreaPlaceholder' | translate }}"
          class="dap-default-area-select"
          id="defaultArea"
          formControlName="defaultArea"
          optionLabel="name"
          optionValue="code"
          filterBy="name"
          size="large"
          [options]="areas"
          [filter]="true"
          [showClear]="batchFormGroup.get('defaultArea')?.value !== ''"
          [appendTo]="'body'"
          [aria-describedby]="'defaultAreaDoctypeDescription'"
        >
        </p-select>
      </div>
    </label>
    @if (batchFormGroup.get('defaultArea')?.value !== '') {
      <label for="defaultDocumentType">
        {{ 'defaultDocumentType' | translate }}
        <div class="select-container">
          <p-select
            placeholder="{{ 'Select Document Type' | translate }}"
            class="dap-default-doc-type-select"
            id="defaultDocumentType"
            formControlName="defaultDocumentType"
            optionLabel="name"
            optionValue="code"
            filterBy="name"
            size="large"
            [options]="filteredDocumentTypes"
            [filter]="true"
            [showClear]="batchFormGroup.get('defaultDocumentType')?.value !== ''"
            [disabled]="!batchFormGroup.get('defaultArea')?.value"
            [appendTo]="'body'"
            [aria-describedby]="'defaultAreaDoctypeDescription'"
          >
          </p-select>
        </div>
      </label>
    }
  </form>
</div>
